/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonAddressInfo = {
    ADDR: string;
    ADDRT: BabylonAddressInfo.ADDRT;
    BL: string;
    BLVAL: string;
    BLP: string;
};

export namespace BabylonAddressInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

